import styles from "../headerBtn.module.scss";

const BlockEmployeeSection = () => {

  const handleTextareaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    console.log(name, value);
  };

  return (
    <div className={styles.block__info}>
      <div className={styles.check__list_block}>
        <div className={styles.limit__block}>
          <span>Причина блокировки:</span>
          <div className={(styles.report__textarea_blockRight)}>
            <textarea
              onChange={handleTextareaChange}
              className={styles.textfield}
              name='commentBlocked'
              rows={10}
              placeholder=' '
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default BlockEmployeeSection;